export default {
  pageTitle: '店铺保证金和免责数信息',
  titleText: '店铺保证金和免责数信息',
  marginAmount: '当前保证金余额',
  marginAmountTips: '余额过少，建议去缴纳',
  curMonth: '当月免责数',
  initial: '初始',
  deducted: '已扣减',
  available: '可用数',
  searchLabel: '查看阅读保证金和免责扣减',
  startYears: '开始月份',
  endYears: '结束月份',
  columns: {
    month: '月份',
    exemptionDeduction: '免责数扣减',
    marginPenaltyDeduction: '保证金处罚扣减',
    unit: '单位'
  }
}
